import { cn } from '@/lib/utils';

interface BudgetBarProps {
  actual: number;
  budget: number;
  /** Visual cap (% used) — defaults to 100. Anything past `budget` shows red. */
}

export function BudgetBar({ actual, budget }: BudgetBarProps) {
  const safeBudget = budget > 0 ? budget : 0;
  const pct = safeBudget > 0 ? Math.min(150, (actual / safeBudget) * 100) : 0;
  const over = safeBudget > 0 && actual > safeBudget;
  return (
    <div className="bg-muted relative h-2 w-full overflow-hidden rounded-full">
      <div
        className={cn(
          'h-full transition-all',
          over ? 'bg-destructive' : pct > 80 ? 'bg-amber-500' : 'bg-primary',
        )}
        style={{ width: `${Math.min(100, pct)}%` }}
      />
    </div>
  );
}
